<template>
  <el-form-item
    prop="orientation"
    class="player-setup-display-orientation pt-2">
    <el-radio
      class="
        horizontal
        bg-[url('@/static/icons/screen-horizontal-icon.png')]
        bg-cover
        mr-[26px]
        w-[53px]
        h-[41px]!
        border
        border-black"
      tabindex="1"
      v-model="model.orientation"
      @change="$emit('change', model.orientation)"
      label="horizontal"></el-radio>
    <el-radio
      class="
        rotateLeft
        bg-[url('@/static/icons/screen-rotate-left-icon.png')]
        bg-cover
        mr-[26px]
        h-[53px]!
        w-[41px]
        border
        border-black"
      tabindex="3"
      v-model="model.orientation"
      @change="$emit('change', model.orientation)"
      label="rotateLeft"></el-radio>
    <el-radio
      class="
        rotateRight
        bg-[url('@/static/icons/screen-rotate-right-icon.png')]
        bg-cover
        mr-[26px]
        h-[53px]!
        w-[41px]
        border
        border-black"
      tabindex="2"
      v-model="model.orientation"
      @change="$emit('change', model.orientation)"
      label="rotateRight"></el-radio>
    <el-radio
      class="
        flipVert
        bg-[url('@/static/icons/screen-flip-var-icon.png')]
        bg-cover
        mr-[26px]
        w-[53px]
        h-[41px]!
        border
        border-black"
      tabindex="4"
      v-if="!isMultipleDisplay"
      v-model="model.orientation"
      @change="$emit('change', model.orientation)"
      label="flipVert"></el-radio>

    <p class="text-xs input-hint text-center mt-3 w-full">
      <template v-if="isMultipleDisplay">{{ $t('playerSetup.SelectDisplayOrientation') }}</template>
      <template v-else>{{ $t('label.chooseHorizontalOrVerticalScreenOrientations') }}</template>
    </p>
  </el-form-item>
</template>

<script src="./player-setup-display-orientation.js"></script>
<style lang="scss" src="./player-setup-display-orientation.scss"></style>
